import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { patchCoreDataSecurityApplicationsBulkSlice } from './patch';

export const coreDataSecurityApplicationsBulkReducers = combineReducers({
	patch: patchCoreDataSecurityApplicationsBulkSlice.asyncReducers
});

export const coreDataSecurityApplicationsBulkWatchers = combineAllWatchers([
	patchCoreDataSecurityApplicationsBulkSlice.asyncWatchers
]);
